import React, { Component } from "react";
import PropTypes from "prop-types";

import LineSeries from "./LineSeries";
import StraightLine from "./StraightLine";

class TrendIntensitySeries extends Component {
  constructor(props) {
    super(props);
    this.yAccessorForTII = this.yAccessorForTII.bind(this);
    this.yAccessorForSignal = this.yAccessorForSignal.bind(this);
  }

  static yExtents(datum, index, allData, indicator) {
    // Fixed range 0-100 for Trend Intensity Index
    return [0, 100];
  }

  yAccessorForTII(d) {
    const { yAccessor } = this.props;
    return yAccessor(d) && yAccessor(d).tii;
  }

  yAccessorForSignal(d) {
    const { yAccessor } = this.props;
    return yAccessor(d) && yAccessor(d).signal;
  }

  render() {
    const { className, onDoubleClick, onContextMenu } = this.props;
    const { strokeTII, strokeSignal, showZones, overBought, overSold } =
      this.props;
    const { clip } = this.props;

    return (
      <g className={className}>
        {/* Main TII Line */}
        <LineSeries
          yAccessor={this.yAccessorForTII}
          highlightOnHover
          onDoubleClick={onDoubleClick}
          onContextMenu={onContextMenu}
          stroke={strokeTII}
          clip={clip}
        />

        {/* Signal Line */}
        <LineSeries
          yAccessor={this.yAccessorForSignal}
          highlightOnHover
          onDoubleClick={onDoubleClick}
          onContextMenu={onContextMenu}
          stroke={strokeSignal}
          clip={clip}
        />

        {/* Overbought/Oversold Lines */}
        {showZones && (
          <>
            <StraightLine
              highlightOnHover
              onDoubleClick={onDoubleClick}
              onContextMenu={onContextMenu}
              stroke={
                overBought?.stroke || {
                  color: "#B8C2CC",
                  dash: "Dash",
                  width: 1,
                  opacity: 1,
                }
              }
              yValue={overBought?.value !== undefined ? overBought.value : 80}
            />
            <StraightLine
              highlightOnHover
              onDoubleClick={onDoubleClick}
              onContextMenu={onContextMenu}
              stroke={
                overSold?.stroke || {
                  color: "#B8C2CC",
                  dash: "Dash",
                  width: 1,
                  opacity: 1,
                }
              }
              yValue={overSold?.value !== undefined ? overSold.value : 20}
            />
          </>
        )}
      </g>
    );
  }
}

TrendIntensitySeries.propTypes = {
  className: PropTypes.string,
  yAccessor: PropTypes.func.isRequired,
  clip: PropTypes.bool.isRequired,
  strokeTII: PropTypes.object.isRequired,
  strokeSignal: PropTypes.object.isRequired,
  showZones: PropTypes.bool,
  overBought: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.shape({
      value: PropTypes.number,
      stroke: PropTypes.object,
    }),
  ]),
  overSold: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.shape({
      value: PropTypes.number,
      stroke: PropTypes.object,
    }),
  ]),
  onDoubleClick: PropTypes.func,
  onContextMenu: PropTypes.func,
};

TrendIntensitySeries.defaultProps = {
  className: "react-stockcharts-trend-intensity-series",
  clip: true,
  showZones: true,
  overBought: 80,
  overSold: 20,
};

export default TrendIntensitySeries;
